export default __webpack_public_path__ + "static/media/doctors.20b371c0.png";